import useSWR from "swr"
import { useSmoothApi } from "./useSmoothApi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"

type Chatroom = {
  id: number
  user_id: number | null
  agent_id: number | null
  enabled: boolean
  status: number | null
  latest_message_sent_at: string | null
  created_at: string
  updated_at: string
}

export const useChatroom = (props: { userId: number }) => {
  const { getWithToken } = useSmoothApi()
  const chatroomSWR = useSWR<Chatroom>(
    `${SMOOTH_SMOOTHER_API_URL}/users/${props.userId}/chat_room`,
    async (url: string) => {
      const res = await getWithToken(url)
      const data = await res.data?.data

      return data
    }
  )

  if (chatroomSWR.error) {
    console.error(chatroomSWR.error)
  }

  return chatroomSWR
}
